/**
 * @author Max Erekhinskiy <max.erekhinskiy@gmail.com>, Jun 28, 2012 11:51:23 AM
 * @copyright MegaGroup © 2012, megagroup.ru
 */

(function () {
  'use strict';

  var basic = {
    DEBUG: true,

    callbacks: {},
    ws_instance: null,
    ready: false,
    messages: [],
    delayed_send_enabled: true,

    hosts: [],
    current_host_index: 0,
    current_host: '',

    num_closed: 0,
    num_errored: 0,

    transport_object: null,
    was_opened: null,
    packet_token_id: 1,

    createPacketToken: function () {
      return ++this.packet_token_id;
    },

    open: function (host) {
      var transport = this;
      // transport.DEBUG && Onicon.print('[transport] open called, stroed hosts: ', this.hosts, ' arguments: ', host);

      this.setHosts(host);
      var connect_host = this._getHost();

      if (!connect_host) {
        transport.DEBUG && Onicon.error('[transport] no hosts to connect: ', this.hosts);
        return false;
      }

      if (!this.ws_instance) {
        if (!this.transport_object) {
          transport.DEBUG && Onicon.error('[transport] transport object is not defined ');
          return false;
        }

        transport.DEBUG && Onicon.print('[transport] connecting to ', connect_host);
        this.was_opened = false;
        this.ws_instance = new (this.transport_object)(connect_host, 'sample');
        this.ws_instance.onopen = function () {
          transport.DEBUG && Onicon.print('[transport] opened');
          this.was_opened = true;
          setTimeout(function () {
            for (var i in transport.messages) {
              if (!transport.messages.hasOwnProperty(i)) {
                continue;
              }
              var message = transport.messages[i];
              transport.DEBUG && Onicon.print('[transport-out] sending delayed message: ', message);
              transport._send(message);
            }
            transport.messages = [];

            transport.ready = true;
            transport._callback('open');
          }, 1);
        };
        this.ws_instance.onmessage = function (e) {
          transport.DEBUG && Onicon.print('[transport-in] message: ', e.data);
          transport._callback('message', [e.data]);
        };
        this.ws_instance.onclose = function (e) {
          transport.DEBUG && Onicon.print('[transport] close');
          transport.num_closed++;
          transport.messages = [];
          transport.ws_instance = null;
          transport.ready = false;
          transport._callback('close', [e]);
        };
        this.ws_instance.onerror = function (e) {
          transport.DEBUG && Onicon.print('[transport] error');
          transport.num_errored++;
          transport.messages = [];
          transport.ws_instance = null;
          transport.ready = false;
          transport._callback('error', [e]);
        };

        return true;
      } else {
        transport.DEBUG && Onicon.print('[transport] connection already established');
        return false;
      }
    },

    send: function (data) {
      var token = null;
      if (typeof data == 'object') {
        if (data.token) {
          token = data.token;
        } else {
          token = data.token = this.createPacketToken();
        }
      }

      if (this.ws_instance && this.ready) {
        this.DEBUG && Onicon.print('[transport-out] direct send: ', data);
        this._send(data);
      } else {
        if (this.delayed_send_enabled) {
          this.DEBUG && Onicon.print('[transport-out] delayed send: ', data);
          this.messages.push(data);
        } else {
          return false;
        }
      }

      return token;
    },

    close: function () {
      if (this.ws_instance) {
        this.ws_instance.close();
        this.ws_instance = null;
        return true;
      } else {
        return false;
      }
    },

    onopen: function (callback) {
      this._addCallback('open', callback);
      return this;
    },

    onclose: function (callback) {
      this._addCallback('close', callback);
      return this;
    },

    onerror: function (callback) {
      this._addCallback('error', callback);
      return this;
    },

    onmessage: function (callback) {
      this._addCallback('message', callback);
      return this;
    },

    reset: function () {
      this.close();
      this.messages = [];
      this.ws_instance = null;
      this.ready = false;
      this.num_closed = 0;
      this.num_errored = 0;
    },

    setHosts: function (hosts) {
      if (!hosts) {
        return;
      }

      if (typeof(hosts) == 'object') {
        this.hosts = hosts;
        this.current_host_index = this._rand(0, hosts.length - 1);
      } else {
        this.hosts = [hosts];
        this.current_host_index = 0;
      }

      // this.DEBUG && Onicon.print('[transport] set hosts: ', this.hosts, ' current_host_index: ', this.current_host_index);
    },

    setTransportObject: function (object) {
      this.transport_object = object;
    },

    getCurrentHost: function () {
      return this.current_host;
    },

    _addCallback: function (name, callback) {
      if (name && typeof(name) == 'string' && typeof(callback) == 'function') {
        this.callbacks[name] = callback;
        return true
      } else {
        return false;
      }
    },

    _callback: function (name, args) {
      var args = args || [];
      if (this.callbacks[name]) {
        this.callbacks[name].apply(this, args);
      }
    },

    _send: function (data) {
      data = typeof data === 'string' ? data : JSON.stringify(data);
      try {
        return this.ws_instance.send(data);
      } catch (e) {
        Onicon.error('[transport.basic] Error sending data NS_ERROR_NOT_CONNECTED');
        Onicon.log('[Debug Connection]', this.ws_instance, data);
        return false;
      }
    },

    _getHost: function () {
      if (!this.hosts.length) {
        return false;
      }

      var host = this.hosts[this.current_host_index];
      this.current_host_index++;

      if (this.current_host_index == this.hosts.length) {
        this.current_host_index = 0;
      }

      this.current_host = host;
      return host;
    },

    _rand: function (min, max) {
      return Math.round((Math.random() * (max - min))) + min;
    }
  };
  Onicon.lib('transport', basic, true);
})();
